var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHumidity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.564.91c1.524 0 6.527 8.295 6.527 11.482 0 3.7-2.922 6.699-6.527 6.699-.85 0-1.678-.167-2.45-.488a.483.483 0 0 1-.257-.623.462.462 0 0 1 .607-.264c.661.275 1.37.418 2.1.418 3.09 0 5.595-2.61 5.595-5.742-.104-3.335-4.69-10.003-5.631-10.519-.968.548-3.957 5.543-4.709 7.374a.462.462 0 0 1-.614.246.483.483 0 0 1-.24-.63c.854-2.225 4.27-7.836 5.6-7.954zm-2.33 14.832c.257 0 .465.214.465.478a.467.467 0 0 1-.466.479c-.717 0-1.27.957-2.33.957s-1.598-.957-2.332-.957c-.733 0-1.258.957-2.33.957-.747 0-1.478-.375-2.192-1.094a.487.487 0 0 1-.007-.677.458.458 0 0 1 .66-.007c.554.558 1.066.82 1.538.82.654 0 1.252-.956 2.331-.956 1.08 0 1.63.957 2.33.957.7 0 1.189-.957 2.332-.957zm-4-2.914c1.122 0 1.664.957 2.335.957.469.005.979-.257 1.532-.819a.458.458 0 0 1 .66.004c.18.188.179.49-.004.676-.716.727-1.448 1.096-2.197 1.096-1.08 0-1.588-.957-2.327-.957-.74 0-1.262.957-2.33.957s-1.595-.957-2.332-.957a.472.472 0 0 1-.466-.479c0-.264.209-.478.466-.478 1.116 0 1.646.957 2.33.957.683 0 1.21-.957 2.332-.957zm4-2.828c.257 0 .465.214.465.479a.477.477 0 0 1-.466.478c-.774 0-1.238.954-2.33.957-1.09.003-1.588-.957-2.332-.957-.744 0-1.237.957-2.33.957-.747 0-1.478-.375-2.192-1.094a.487.487 0 0 1-.007-.676.458.458 0 0 1 .66-.007c.554.557 1.066.82 1.538.82.676-.003 1.23-.957 2.331-.957 1.1 0 1.634.959 2.33.957.695-.002 1.215-.957 2.332-.957z",
    fill: "#78C081"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidity);
export default __webpack_public_path__ + "static/media/humidity.dc7a81c7e3a368a0e4338474a7b45e40.svg";
export { ForwardRef as ReactComponent };